import { query } from "@solidjs/router";
import { getCookie } from "./utils.js";

export const getRunbooks = query(async () => {
  const token = getCookie("token");
  const response = await fetch("/api/runbooks", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    throw new Error("Failed to fetch runbooks");
  }

  const result = await response.json();

  if (!result) {
    return [];
  }

  return result;
}, 'runbooks');


export const getRunbook = query(async (id) => {
  const token = getCookie("token");
  const response = await fetch(`/api/runbooks/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    throw new Error("Failed to fetch runbook");
  }

  return await response.json();
}, 'runbook');

export const upsertBook = async (runbook) => {
  const token = getCookie("token");
  const response = await fetch('/api/runbooks', {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(runbook)
  });

  if (!response.ok) {
    throw new Error("Failed to fetch runbook");
  }

  return await response.json();
}

export const deleteRunbook = async (id) => {
  const token = getCookie("token");
  const response = await fetch(`/api/runbooks/${id}`, {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    throw new Error("Failed to delete runbook");
  }

  return await response.json();
}
